export default __webpack_public_path__ + "static/media/YOOZ-Bill-Pay-Agent-Network-SECURITY-1440x465.91760888.png";